export default __webpack_public_path__ + "static/media/git.a7cb412d.png";